export const createFitIntoViewHandler = (fitIntoView) => () => {
  fitIntoView();
};
